<h2 mat-dialog-title>Entrar em contato</h2>
<div mat-dialog-content>
  <p>Escolha uma das opções abaixo.</p>
  <div class="contact-item" *ngFor="let item of contacts">
    {{ item.imobiliaria.nome }}
    <ng-container *ngIf="item.entrarEmContato === 'C'">
      -
      {{ item.usuarioImobiliaria?.nome }}
    </ng-container>
    <div class="button-container">
      <button class="btn btn-default btn-block" (click)="openWhatsApp()">
        <span>Chamar pelo whatsapp</span>
      </button>
      <button class="btn btn-default btn-block" (click)="makeCall(item)">
        <span>Ligar</span>
      </button>
    </div>
  </div>
</div>
